export default "__VITE_PUBLIC_ASSET__ba448af9__"